import { call, put, takeEvery, takeLatest, delay, select } from "redux-saga/effects";
import { apiError, fetchedCameraDataToPlotGraph, fetchedCountStart, fetchedDataToPlotGraph, fetchedExitDataToPlotGraph, fetchedReportDetails, fetchedTags, siteTagListUpdated, types, updateAreaTags, updateReportsPolling } from "../actions";
import { fetchedReports } from "../actions";
import { fetchReportsData, fetchTagData, fetchGraphData, fetchReportData, fetchCameraGraphData, fetchPeriodicReports, fetchExitGraphData, fetchAreaTags, fetchGraphStartCount, filterAndStoreData, getUserSitesData } from "../../model/reportService";
import { getUserSites } from "../../model/roleService";

const POLLING_DELAY = 10000; // Poll every 30 seconds

const getTagData = (state) => state.reportReducer.tagData;
const getNetTrafficFlowInterval = (state) => state.reportReducer.netTrafficFlowInterval;
const shouldPollForReports = (state) => state.reportReducer.shouldPollForReports;
const getAreaTags = (state) => state.reportReducer.areaTagData;
const getGlobalTimeRange = (state) =>state.reportReducer.dropdownValue;
const activeSession = (state) => state.sessionReducer.activeSession;


function* ReportSaga() {
    yield takeLatest(types.START_POLLING_FOR_REPORTS, startPollingReports);
    yield takeEvery(types.STOP_POLLING_FOR_REPORTS, stopPollingReports);
    yield takeEvery(types.FETCH_TAGS, fetchTags);
    yield takeEvery(types.FETCH_GRAPH_DATA, fetchGraphDataToPlot);
    yield takeEvery(types.FETCH_EXIT_GRAPH_DATA, fetchExitGraphDataToPlot);
    yield takeEvery(types.FETCH_REPORT_DETAILS, fetchReportDetails);
    yield takeEvery(types.FETCH_CAMERA_GRAPH_DATA, fetchCameraGraphDataToPlot);
    yield takeEvery(types.FETCH_COUNTER_COUNT, fetchCountStart);
}

function* pollReportService() {
    try {
      const session = yield select(activeSession);
      let payload = {};
      payload.areaTagData = yield select(getAreaTags);
      payload.trafficFlowInterval = yield select(getNetTrafficFlowInterval);
      payload.deductTime = yield select( getGlobalTimeRange);
      const reportData = yield call(fetchPeriodicReports, payload, session.activeSession);
      yield put(fetchedReports(reportData));
    } catch (error) {
      console.log("Error while getting reports -> " + error );
    }
  }
  
  function* startPollingReports() {
    yield put(updateReportsPolling(true))
    yield call(pollReportService);
    while (shouldPollForReports) {
      yield delay(POLLING_DELAY);
      yield call(pollReportService);
    }
  }
  
  function* stopPollingReports() {
    yield put(updateReportsPolling(false))
  }

  function* fetchTags() {
    try {
      const session = yield select(activeSession);
      const tagData = yield call(fetchTagData, session.activeSession);
      const userSiteData = yield call(getUserSitesData, session.activeSession)
      const siteTagList = filterAndStoreData(tagData, userSiteData);
      yield put(siteTagListUpdated(siteTagList));
      if (tagData.error) {
        yield put(apiError(true));
      } else {
        yield put(fetchedTags(tagData));
        const areaTags = yield call(fetchAreaTags, tagData);
        yield put(updateAreaTags(areaTags));
        yield put(apiError(false));
      }
    } catch (error) {
      console.log("Error while getting tags -> " + error );
    }
  }

  function* fetchGraphDataToPlot({payload}) {
    try {
      const session = yield select(activeSession);
      payload.tagData = yield select(getTagData);
      const graphData = yield call(fetchGraphData, payload, session.activeSession);
      yield put(fetchedDataToPlotGraph(graphData));
    } catch (error) {
      console.log("Error while getting graph data -> " + error );
    }
  }

  function* fetchCountStart({payload}){
    try {
      const session = yield select(activeSession);
      const graphData = yield call(fetchGraphStartCount, payload, session.activeSession);
      yield put(fetchedCountStart(graphData));
    } catch (error) {
      console.log("Error while getting graph data -> " + error );
    }
  }

  function* fetchExitGraphDataToPlot({payload}) {
    try {
      const session = yield select(activeSession);
      payload.tagData = yield select(getTagData);
      const graphData = yield call(fetchExitGraphData, payload, session.activeSession);
      yield put(fetchedExitDataToPlotGraph(graphData));
    } catch (error) {
      console.log("Error while getting graph data -> " + error );
    }
  }

  function* fetchCameraGraphDataToPlot({payload}) {
    try {
      const session = yield select(activeSession);
      const graphData = yield call(fetchCameraGraphData, payload, session.activeSession);
      yield put(fetchedCameraDataToPlotGraph(graphData));
    } catch (error) {
      console.log("Error while getting graph data -> " + error );
    }
  }

  function* fetchReportDetails({payload}) {
    try {
      const session = yield select(activeSession);
      const tagData = yield select(getTagData);
      payload.tagData = tagData;
      const reportDetailsData = yield call(fetchReportData, payload, session.activeSession)
      yield put(fetchedReportDetails(reportDetailsData));
    } catch (error) {
      console.log("Error while getting report details -> " + error );
    }
  }
  export default ReportSaga;